import { TokenService } from '@package/service'
import { defineStore } from '@main/common/config/defineStore'
import { apiGetRouter, apiGetUserPowers, apiPostLogin, apiPostLogout } from '../api/index'
import { EnumApiCode } from '../../../../../../globalEnum.js'
import baseMenu from '../config/baseMenu.js'
import baseAndContractMenu from '../config/baseAndContractMenu.js'
import contractMenu from '../config/contractMenu.js'

// import { defineStore } from 'pinia'
// 第一个参数是应用程序中 store 的唯一 id
export default defineStore('login', {
  state: () => ({
    user: {},
    menus: [],
    perms: []
  }),
  // 相当于 vue 中的 computed 计算属性 返回一个数值
  getters: {
    userInfo(state) {
      return state?.user ?? ''
    },
    /**
     * 权限菜单
     * @param state
     * @return {any}
     */
    permissionsMenu: (state) => state?.menus ?? '',
    /**
     * 权限菜单
     * @param state
     * @return {any}
     */
    permissionsActions: (state) => state?.perms ?? [],
    /**
     * 头像地址
     * @param state
     * @return {string}
     */
    avatar(state) {
      const url = state.user?.avatarUrl ?? ''
      return url.indexOf('##') !== -1 ? url.split('##')[0] : url
    },
    userName(state) {
      return state.user?.realName ?? ''
    },
    getMenuPerimis(state) {
      return (url) => {
        const list = JSON.stringify(state.menus)
        return list.indexOf(url) !== -1
      }
    }
  },
  actions: {
    LoginIn(userInfo) {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            const { data, code } = await apiPostLogin(userInfo)
            if (code === EnumApiCode.Success) {
              TokenService.setToken('TokenNew', data.access_token)
              resolve()
            } else {
              reject("登录失败")
            }
          } catch (error) {
            reject("登录失败")
          }
        })()
      })
    },
    getInfo() {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            const { data } = await apiGetUserPowers()
            this.user = data
            resolve(data)
          } catch (error) {
            reject(error)
          }
        })()
      })
    },
    // 退出系统
    LogOut() {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            const formData = new FormData()
            formData.append('token', TokenService.getToken('TokenNew'))
            const res = await apiPostLogout(formData)
            this.user = {}
            this.menus = []
            this.perms = []
            TokenService.removeToken('TokenNew')
            resolve(res)
          } catch (error) {
            reject(error)
          }
        })()
      })
    },
    getUserMenus() {
      return new Promise((resolve, reject) => {
        ;(async () => {
          try {
            // if(1) {
            //   this.menus = import.meta.env.VITE_APP_ENABLE_REGISTER === 'true' ? devMenu : testMenu
            // }

            //dev和test
            if(this.user.passFlag == 1) {
              this.menus = baseAndContractMenu
            }else {
              this.menus = baseMenu
            }

            //prod
            // this.menus = contractMenu

            resolve()
          } catch (error) {
            reject(error)
          }
        })()
      })
    },
    setAvatar(url) {
      this.user = { ...this.user, avatarUrl: url }
    }
  }
})
